import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { PlatformProvider } from './context/PlatformContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AppLayout from './components/layout/AppLayout';
import Dashboard from './pages/Dashboard';
import Candidates from './pages/Candidates';
import Settings from './pages/Settings';
import PublicVerify from './pages/PublicVerify';
import Recruitment from './pages/Recruitment';
import Operations from './pages/Operations';
import Portal from './pages/Portal';
import Certificates from './pages/Certificates';
import Verification from './pages/Verification';
import Wallet from './pages/Wallet';
import EmailCenter from './pages/EmailCenter';
import InternshipPrograms from './pages/InternshipPrograms';
import ProgramDetail from './pages/ProgramDetail';
import GlobalAnalytics from './pages/GlobalAnalytics';
import Templates from './pages/Templates';
import PublicApply from './pages/PublicApply';

function App() {
  return (
    <AuthProvider>
      <PlatformProvider>
        <HashRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              className: '!bg-white !text-slate-800 !border !border-slate-200 !rounded-2xl !p-4 !shadow-2xl !shadow-slate-200/50',
              success: { iconTheme: { primary: '#10B981', secondary: '#fff' } },
              error: { iconTheme: { primary: '#EF4444', secondary: '#fff' } },
            }}
          />
          <Routes>
            {/* ── PUBLIC routes — no auth required ── */}
            <Route path="/verify/:id" element={<PublicVerify />} />
            <Route path="/apply/:orgSlug" element={<PublicApply />} />

            {/* ── PROTECTED routes — require login ── */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/programs" replace />} />
              <Route path="programs" element={<InternshipPrograms />} />
              <Route path="programs/:programId" element={<ProgramDetail />} />
              <Route path="analytics" element={<GlobalAnalytics />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="candidates" element={<Candidates />} />
              <Route path="recruitment" element={<Recruitment />} />
              <Route path="operations" element={<Operations />} />
              <Route path="certificates" element={<Certificates />} />
              <Route path="templates" element={<Templates />} />
              <Route path="email" element={<EmailCenter />} />
              <Route path="verification" element={<Verification />} />
              <Route path="wallet" element={<Wallet />} />
              <Route path="portal" element={<Portal />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </HashRouter>
      </PlatformProvider>
    </AuthProvider>
  );
}

export default App;